import React,{useState,useEffect, useRef} from 'react'
import AppHeader from '../components/AppHeader'
import portalServices from '../portalServices';
import { Link, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { ArrowRight, CalendarMonth, Person, WorkOutline } from '@mui/icons-material';
import SelfCancel from '../components/SelfCancel';
import QueueWorkingHours from '../components/QueueWorkingHours';
import VisitorReportingTime from '../components/VisitorReportingTime';
import OTPLoginPage from '../components/OTPLoginPage';
import RequestNotificationPermission from '../../../notifications/components/RequestNotificationPermission';


const TokenDetailsView = ({tokenDetails,getTokenDetails}) =>{ // This is not route page This component will show details only 

  const printComponentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    pageStyle:"@page { size: 2.5in 2.5in; margin: 0; padding:0 }, @media print { @page {  size: 2.5in 2.5in margin: 0mm !important;  body,html{padding:0px;margin:0px;} } }",
    //pageStyle:"@media print { html, body { height: 2.5in; /* Use 100% here to support printing more than a single page*/ margin: 0 !important;padding: 0 !important;overflow: hidden;}}; @page { size: 2.5in 2.5in; margin: 0; }"
    //onAfterPrint:()=>{navigate("/kiosk/dashboard")}
  });
  return (
    <div className="card mb-2" >
      <div className="card-body" >
          <div className='row'>
            <div className='col-md-6'>
              
                <div ref={printComponentRef}>
                  <div className='row ps-3'>
                    <div className="col-xs-12">
                        <div className="rounded">
                            <h4 className="mt-2">{tokenDetails.prefix}-{tokenDetails.tokenNo}</h4>
                        </div>
                    </div>
                    <div className="col-xs-12">
                            {tokenDetails.profileImage!== null &&
                                <img src={tokenDetails.profileImage} className="img-thumbnail"
                                style={{height:".8in", width:".8in"}}
                                alt="Visitor Photo" />
                            }
                            <div style={{fontSize:10, lineHeight:0}} ><Person/>: {tokenDetails.firstName}</div>
                            <div style={{fontSize:10, lineHeight:0}} ><CalendarMonth/> : {moment(tokenDetails.checkinDate).format("LL")}</div>
                            <div style={{fontSize:10, lineHeight:0}} ><WorkOutline/> : {tokenDetails.queueTitle} <ArrowRight/> {tokenDetails.serviceTitle}</div>
                    </div>
                  </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
              
                <div>
                  <VisitorReportingTime tokenDetails={tokenDetails} />
                </div>
                <div>
                  <SelfCancel getTokenDetails={getTokenDetails} tokenDetails={tokenDetails} />
                  <button type="button" onClick={()=>handlePrint()} className="btn btn-success btn-lg" >Print</button>
                </div>
              
            </div>
          </div>
          
          
      </div>
    </div>
  )
}


const AppointmentDetailsView = ({appointmentDetails}) => {
  return (
    <div className='card mb-2'>
      <div className='card-body'>
        <div className="rounded">
          <h4 className="mt-2">A-{appointmentDetails.prefix}-{appointmentDetails.tokenNo}</h4>
        </div>
        <div className=''>
            {appointmentDetails.profileImage!== null &&
                <img src={appointmentDetails.profileImage} className="img-thumbnail"
                style={{height:".8in", width:".8in"}}
                alt="Visitor Photo" />
            }
            <div style={{fontSize:10, lineHeight:0}} ><Person/>: {appointmentDetails.firstName}</div>
            <div style={{fontSize:10, lineHeight:0}} ><CalendarMonth/> : {moment(appointmentDetails.appointmentDateTime).format("LLL")}</div>
            <div style={{fontSize:10, lineHeight:0}} ><WorkOutline/> : {appointmentDetails.queueTitle} <ArrowRight/> {appointmentDetails.serviceTitle}</div>
          
        </div>
      </div>
    </div>
  )
}


function TokenDetailsPage() {

  const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);

  const [tokenList,setTokenList] = useState([]);
  const getTokenDetails = () =>{
    if(customerToken){
      portalServices.getTokenDetails({customerToken:customerToken}).then(res=>{
        setTokenList(res.data);
      }).catch(error=>{
        console.log(error)
      })
    }
  }

  const [appointmentList,setAppointmentList] = useState([]);
  const getAppointmentList = () =>{
    if(customerToken){
      portalServices.getAppointmentList({customerToken:customerToken}).then(res=>{
        setAppointmentList(res.data);
      }).catch(error=>{
        console.log(error)
      })
    }
  }

  useEffect(()=>{
    getTokenDetails();
    getAppointmentList();
  },[customerToken])


  const navigate = useNavigate();
  
  return (
    <>
        <AppHeader/>
        <div className='container'>
            {
              (customerToken === null || customerToken === undefined)?
                <OTPLoginPage
                  setCustomerToken={setCustomerToken}
                /> 
              :

                <div className='row mt-4'>
                  <RequestNotificationPermission/>
                  {tokenList.length > 0 &&
                    <div className='col-md-6'>
                      <h3>Today's Token</h3>
                      <hr/>
                      {tokenList?.map((tokenDetails,index) => 
                        tokenDetails.checkinDate === moment(tokenDetails.created_at).format("YYYY-MM-DD") &&
                        <TokenDetailsView tokenDetails={tokenDetails} key={index} getTokenDetails={getTokenDetails}/>
                      )}
                      <h3>Scheduled Token</h3>
                      {tokenList?.map((tokenDetails,index) => 
                        tokenDetails.checkinDate !== moment(tokenDetails.created_at).format("YYYY-MM-DD") &&
                        <TokenDetailsView tokenDetails={tokenDetails} key={index} getTokenDetails={getTokenDetails}/>
                      )}
                    </div>
                  }
                  <div className='col-md-6'>
                      <h3>Upcoming Appointment</h3>
                      <hr/>
                      <div className='row'>
                        {appointmentList.map(appointment=>
                          <div className='col-md-12' key={appointment.id}>
                            <AppointmentDetailsView appointmentDetails={appointment} />
                          </div>
                        )}
                      </div>
                  </div>
                  <div className="col-md-12 text-center mt-3">
                    { (tokenList.length > 0 || appointmentList.length > 0) &&
                      <Link to={"/"} type="button"  className="btn btn-outline-success btn-lg" >Book Another Token</Link>
                    }
                    {tokenList.length === 0 && appointmentList.length == 0 &&
                      <div>
                      <h5>No token token yet.</h5>
                      <Link to={"/"} className='btn btn-outline-primary'>Book a Token</Link>
                      </div>
                    }
                  </div>
                </div>
            }
        </div>
    </>
  )
}

export default TokenDetailsPage